// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WwtSX","badges":"styles_badges__OELlN"};